<template lang="html">
<div class="chart-tooltip elevation-3 white" :style="styles">
    <div v-for="line in content">
        <div v-if="'text' in line" :class="line.class" class="text">
            {{ line.text }}
        </div>
        <div v-if="'label' in line" :class="line.class" class="label-value">
            <div class="label">{{ line.label }}:</div>
            <div class="value">{{ line.value }}</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        top: {
            type: Number,
            required: true,
        },
        left: {
            type: Number,
            required: true,
        },
        content: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {

        };
    },
    computed: {
        styles() {
            return {
                top: `${this.top}px`,
                left: `${this.left}px`,
            };
        },
    },
};
</script>

<style lang="scss">
.chart-tooltip {
    pointer-events: none;
    flex-direction: column;
    position: absolute;
    padding: .25rem;
    display: flex;

    .label-value {
        padding: 0 .25rem;
        display: flex;
        justify-content: space-between;
    }
    .text {
        padding: 0 .25rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ChartTooltip.vue